import React from "react";
import "./CommunicationUnreadBadge.css";

export default function CommunicationUnreadBadge({ count }) {
  const total = Math.max(0, Math.floor(Number(count) || 0));
  if (total === 0) return null;

  const label = `${total} unread ${total === 1 ? "message" : "messages"}`;

  return (
    <span
      className="legup-communication-unread-badge"
      title={label}
      aria-label={label}
    >
      {total > 99 ? "99+" : total}
    </span>
  );
}
